// 1. Hide GSAP trial warning messages from appearing in the console
if (typeof gsap !== "undefined") {
  gsap.config({ trialWarn: false });
}

document.addEventListener("DOMContentLoaded", function () {
  // Check if both GSAP and SplitText libraries are loaded before running
  if (typeof gsap === "undefined" || typeof SplitText === "undefined") return;

  gsap.registerPlugin(SplitText);

  const heading = document.querySelector(".esb-heading");
  const headingSub = document.querySelector(".esb-heading-sub"); // h2 selector
  const subtext = document.querySelector(".esb-subtext");

  const tl = gsap.timeline({ delay: 0.3 });

  // 1. Handle .esb-heading (Original h1 character animation)
  if (heading) {
    const splitHeading = new SplitText(heading, {
      type: "words, chars",
      wordsClass: "split-word",
      charsClass: "split-char",
    });

    gsap.set(splitHeading.chars, {
      y: 80,
      rotationX: -90,
      opacity: 0,
      transformOrigin: "50% 50% -20",
    });

    tl.to(splitHeading.chars, {
      y: 0,
      rotationX: 0,
      opacity: 1,
      duration: 1.2,
      ease: "back.out(1.2)",
      stagger: { amount: 0.6, from: "center" },
    });
  }

  // 2. Handle .esb-heading-sub (h2 Fade-up - Without using SplitText)
  if (headingSub) {
    // Initial state (positioned slightly lower and transparent)
    gsap.set(headingSub, {
      y: 30,
      opacity: 0,
    });

    // Triggers a smooth fade-up effect just before the h1 animation completes
    tl.to(
      headingSub,
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: "power2.out",
      },
      "-=0.4", // Overlap timing value can be adjusted here if needed
    );
  }

  // 3. Handle .esb-subtext (Simple animation with optimized execution timing)
  if (subtext) {
    // Initial state
    gsap.set(subtext, {
      y: 25,
      opacity: 0,
    });

    // Executes smoothly 0.2 seconds after the h2 animation starts for perfect visual sequence
    tl.to(
      subtext,
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: "power2.out",
      },
      "-=0.2", // Synchronized overlap window with the h2 element
    );
  }
});
